// <s-recently-viewed> — remembers the product pages a visitor opens (handles in localStorage, this device only)
// and shows up to four earlier ones, built from the <template data-card> markup so styling lives in Liquid.
// Product data comes from the storefront /products/{handle}.js endpoint in the visitor's active currency.
const KEY = 'niya:recently-viewed';
const MAX_STORED = 12;
const MAX_SHOWN = 4;

class SRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.current;
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { handles = []; }
    if (!Array.isArray(handles)) handles = [];
    const earlier = handles.filter((h) => typeof h === 'string' && h !== current);
    try { localStorage.setItem(KEY, JSON.stringify([current, ...earlier].slice(0, MAX_STORED))); } catch { /* storage unavailable */ }

    const wanted = earlier.slice(0, MAX_SHOWN + 2);
    if (!wanted.length) return;
    const root = window.Shopify?.routes?.root || '/';
    const results = await Promise.all(wanted.map(async (handle) => {
      try {
        const res = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
        return res.ok ? await res.json() : null;
      } catch { return null; }
    }));
    const products = results.filter((p) => p && p.available !== undefined).slice(0, MAX_SHOWN);
    if (!products.length) return;

    const template = this.querySelector('template[data-card]');
    const list = this.querySelector('[data-list]');
    if (!template || !list) return;
    const currency = window.Shopify?.currency?.active;
    const locale = document.documentElement.lang || undefined;
    const format = (cents) => {
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100); }
      catch { return (cents / 100).toFixed(2); }
    };
    const sized = (src, width) => {
      if (!src) return '';
      const url = src.startsWith('//') ? `https:${src}` : src;
      return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
    };

    for (const product of products) {
      const node = template.content.cloneNode(true);
      const link = node.querySelector('[data-link]');
      link.href = product.url;
      link.setAttribute('aria-label', product.title);
      const main = node.querySelector('[data-image]');
      main.src = sized(product.featured_image, 600);
      main.srcset = `${sized(product.featured_image, 375)} 375w, ${sized(product.featured_image, 600)} 600w`;
      main.alt = product.title;
      const hover = node.querySelector('[data-hover-image]');
      if (product.images && product.images[1]) {
        hover.src = sized(product.images[1], 600);
      } else {
        hover.remove();
        main.classList.remove('group-hover/card:opacity-0');
      }
      node.querySelector('[data-title]').textContent = product.title;
      node.querySelector('[data-price]').textContent = product.price_varies ? `${this.dataset.fromLabel} ${format(product.price_min)}` : format(product.price);
      list.append(node);
    }
    this.hidden = false;
  }
}

if (!customElements.get('s-recently-viewed')) customElements.define('s-recently-viewed', SRecentlyViewed);
